{
  "mappings": [
    {
      "category": "User Communication Data",
      "titles": [
        "messages.csv",
        "guide_messages.csv",
        "learning_coach_messages.csv",
        "learning_role_play_messages.csv",
        "note_interactions.json"
      ]
    },
    {
      "category": "User-Generated Content",
      "titles": ["Rich_Media.csv", "media", "stories", "stories.json", "profile_photos.json", "camera_information.json"]
    },
    {
      "category": "Profile and Social Graph Data",
      "titles": [
        "Profile.csv",
        "Profile Summary.csv",
        "Connections.csv",
        "Member_Follows_1190571946.csv",
        "close_friends.json",
        "followers_1.json",
        "followers_and_following",
        "following.json",
        "connections",
        "recent_follow_requests.json",
        "follow_requests_you've_received.json",
        "pending_follow_requests.json",
        "recently_unfollowed_profiles.json",
        "removed_suggestions.json",
        "hide_story_from.json",
        "comments_allowed_from.json",
        "instagram_friend_map.json"
      ]
    },
    {
      "category": "Usage Data",
      "titles": [
        "profile_activity.json",
        "profile_searches.json",
        "recent_searches",
        "link_history",
        "link_history.json",
        "videos_watched.json",
        "posts_viewed.json",
        "likes",
        "liked_posts.json",
        "liked_comments.json",
        "Reactions_1190571946.csv",
        "note_interactions.json",
        "notification_preferences.json",
        "settings",
        "preferences",
        "subscription_for_no_ads.json"
      ]
    },
    {
      "category": "Transaction Data",
      "titles": ["no_matching_file"]
    },
    {
      "category": "Device and Network Information",
      "titles": ["device_information", "last_known_location.json", "login_activity.json"]
    },
    {
      "category": "Tracking and Third-Party Data",
      "titles": [
        "Ad_Targeting.csv",
        "ad_preferences.json",
        "ads_and_topics",
        "ads_information",
        "ads_viewed.json",
        "other_categories_used_to_reach_you.json",
        "instagram_ads_and_businesses"
      ]
    },
    {
      "category": "Sensitive Personal Information",
      "titles": ["no_matching_file"]
    },
    {
      "category": "AI Interaction Data",
      "titles": ["no_matching_file"]
    },
    {
      "category": "Activity Metadata",
      "titles": [
        "logged_information",
        "login_and_profile_creation",
        "signup_details.json",
        "security_and_login_information",
        "password_change_activity.json",
        "autofill_information",
        "autofill_information.json",
        "information_about_you",
        "personal_information",
        "personal_information.json",
        "possible_phone_numbers.json",
        "your_instagram_activity"
      ]
    },
    {
      "category": "Contact and Profile Information",
      "titles": [
        "Email Addresses.csv",
        "PhoneNumbers.csv",
        "Registration.csv",
        "personal_information.json",
        "professional_information.json"
      ]
    },
    {
      "category": "Content Interaction Data",
      "titles": [
        "likes",
        "liked_posts.json",
        "liked_comments.json",
        "Reactions_1190571946.csv",
        "posts_you're_not_interested_in.json",
        "Saved Jobs.csv",
        "SavedJobAlerts.csv",
        "Jobs"
      ]
    }
  ]
}
